var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutoutBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 21,
    viewBox: "0 0 42 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.40202 0 0 9.40202 0 21H42C42 9.40202 32.598 0 21 0Z",
    fill: "#E6E7E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutoutBottom);
export default __webpack_public_path__ + "static/media/CutoutBottom.ee0c799b09a9540695a8ae17bf8f2c69.svg";
export { ForwardRef as ReactComponent };